import { render, staticRenderFns } from "./TableGroup.vue?vue&type=template&id=22a8d0aa&"
import script from "./TableGroup.vue?vue&type=script&lang=ts&"
export * from "./TableGroup.vue?vue&type=script&lang=ts&"
import style0 from "./TableGroup.vue?vue&type=style&index=0&id=22a8d0aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports